import { MerchPageContentBlock, merchPageContentBlocks } from 'app/blocks'
import { gql } from 'graphql-request'

export interface MerchPageContent {
  pageContent: MerchPageContentBlock[]
  purchasableCollectiblesTitle?: string | null
  purchasableCollectiblesDescription?: string | null
  collectiblesRoadmap?: {
    id: string
    year?: number | null
    quarters?: Array<{
      quarter?: string | null
      collectible?: {
        id: string
      } | null
    }> | null
  } | null
}

export const createMerchPageQuery = () => gql`
  ${merchPageContentBlocks}
  query getMerchPage {
    Merch {
      purchasableCollectiblesTitle
      purchasableCollectiblesDescription
      collectiblesRoadmap {
        id
        year
        quarters {
          quarter
          collectible {
            id
          }
        }
      }
      pageContent {
        __typename
        ...bannerFragment
        ...callToActionFragment
        ...merchCollectiblesCallToActionFragment
        ...productGridFragment
        ...promoCodeFragment
      }
    }
  }
`

export const mapToMerchPageContent = (data: any): MerchPageContent => {
  const pageContent = (data.Merch.pageContent || []).map((block: any) => {
    if (block?.__typename !== 'MerchCollectiblesCallToAction') {
      return block
    }

    return {
      ...block,
      title: block.title ?? block.merchCollectiblesTitle,
      ctaLabel: block.ctaLabel ?? block.merchCollectiblesCtaLabel,
      ctaHref: block.ctaHref ?? block.merchCollectiblesCtaHref,
    }
  })

  return {
    pageContent: pageContent as MerchPageContentBlock[],
    purchasableCollectiblesTitle: data.Merch.purchasableCollectiblesTitle,
    purchasableCollectiblesDescription:
      data.Merch.purchasableCollectiblesDescription,
    collectiblesRoadmap: data.Merch.collectiblesRoadmap,
  }
}
